import React from "react";
import { Link } from "react-router-dom";
import "./SmarterMove.css";
import sideImage from "../assets/smarter.jpg"; // replace with your image path

export default function SmarterMove() {
  return (
    <section className="smarter-section">
      <div className="smarter-container">
        {/* Left Side - Content */}
        <div className="smarter-left">
          <h2 className="smarter-title">
            Are You Ready to Make the Smarter Move?
          </h2>
          <p className="smarter-subtitle">
            Because we’re ready when you are, with better pricing, better service, and zero excuses.
          </p>

          <Link to="/contact" className="smarter-btn">
            Get in Touch Now
          </Link>
        </div>

        {/* Right Side - Image */}
        <div className="smarter-right">
          <img src={sideImage} alt="Smarter Move" className="smarter-image" />
        </div>
      </div>
    </section>
  );
}
